document.addEventListener('DOMContentLoaded', () => {
  let lastFocus = null;
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('drawer-lock');
    if (lastFocus) lastFocus.focus();
  };
  const openDrawer = (drawer, opener) => {
    if (!drawer) return;
    lastFocus = opener;
    drawer.hidden = false;
    document.body.classList.add('drawer-lock');
    const panel = drawer.querySelector('.pdp-size-drawer__panel');
    if (panel) panel.focus();
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-drawer-open]');
    if (opener) {
      const drawer = document.getElementById(opener.dataset.sizeDrawerOpen);
      openDrawer(drawer, opener);
    }
    const closer = event.target.closest('[data-size-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-size-drawer]'));
  });
  document.addEventListener('keydown', (event) => {
    const openDrawers = document.querySelectorAll('[data-size-drawer]:not([hidden])');
    if (event.key === 'Escape') openDrawers.forEach(closeDrawer);
    openDrawers.forEach((drawer) => {
      const panel = drawer.querySelector('.pdp-size-drawer__panel');
      if (panel && window.LoftyLlama?.trapFocus) window.LoftyLlama.trapFocus(panel, event);
    });
  });
});
